<template>
  <homeMobile v-if="screenWidth <= 1024" />
  <router-view v-else />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import homeMobile from "./views/home-mobile/home-mobile.vue";

export default defineComponent({
  components: { homeMobile },

  data() {
    return {
      screenWidth: document.body.clientWidth,
    };
  },

  mounted() {
    window.onresize = () => {
      let width = document.body.clientWidth;
      if ((this.screenWidth <= 1024 && width > 1024) || (this.screenWidth > 1024 && width <= 1024)) {
        location.reload();
      }
      this.screenWidth = width;
    };
  },
})
</script>